import onInit from "../utils/onInit";
import * as GroupToggle from "../components/GroupToggle";
import Cmd from "../utils/Cmd";
function initScrollingToActiveTab() {
    const containerEl = document.querySelector(".m-group-nav__list--tabs");
    if (!containerEl) {
        return;
    }
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            var _a, _b;
            if (mutation.attributeName === "class" &&
                mutation.target instanceof HTMLElement &&
                mutation.target.classList.contains("is-active")) {
                containerEl.scrollTo((_b = (_a = mutation.target.parentElement) === null || _a === void 0 ? void 0 : _a.offsetLeft) !== null && _b !== void 0 ? _b : mutation.target.offsetLeft, 0);
            }
        });
    });
    observer.observe(containerEl, {
        attributes: true,
        attributeFilter: ["class"],
        subtree: true,
    });
}
function getTarget(item) {
    return (GroupToggle.utils.getItemFromHash(item.getAttribute("href") || "") ||
        item.getAttribute("data-target") ||
        "");
}
function init(state = "") {
    return [state, Cmd.none];
}
export default {
    /**
     * Initiate GroupToggleNav state.
     *
     * @param {string} state Current item.
     */
    init: init,
    update: (state, action) => {
        switch (action.type) {
            case "CHANGE_ITEM":
                return [action.target, Cmd.none];
        }
        return [state, Cmd.none];
    },
    view: (elements, state, dispatch) => {
        elements.forEach((link) => {
            if (getTarget(link) === state) {
                link.classList.add("is-active");
            }
            else {
                link.classList.remove("is-active");
            }
        });
        onInit(elements[0], () => {
            elements.forEach((el) => {
                el.addEventListener("click", (e) => {
                    const target = getTarget(e.currentTarget);
                    if (GroupToggle.utils.isGroupToggleItem(target)) {
                        dispatch({ type: "CHANGE_ITEM", target });
                        e.preventDefault();
                    }
                });
            });
            initScrollingToActiveTab();
        });
    },
};
